//Default Flow Sheet to initialize editable items when creating a new entity in the editor
//Frozen so this default can't be changed by users.
export const defaultItem_FlowSheet = Object.freeze({
    label: 'New Flow Sheet'
});
//# sourceMappingURL=consts.js.map